<template lang="pug">
.padding
    .margin
        h5._300.m-b-0 {{ trans('general.order_layout') }}
        small Build your {{ trans('general.order_layout').toLowerCase() }} to quickly access frequently used products, variants or discounts

    .box
        v-server-table(
            ref="datatable",
            :url="url",
            :name="tableName",
            :columns="columns",
            :options="options",
            @loaded="onLoaded"
        )

            div(slot="grid_size" slot-scope="props") {{ props.row.width }} x {{ props.row.height }}

            div(slot="outlet_id" slot-scope="props") {{ props.row.outlet.name }}

            div(slot="centrals" slot-scope="props")
                collection-counter(
                    :subject="centrals"
                    :collection="props.row.centrals"
                )

            div(slot="action" slot-scope="props")
                button.btn.btn-icon.btn-sm.info(
                    data-toggle="tooltip"
                    v-if="canManageOrderLayout"
                    title="Copy"
                    @click="showCloneForm(props.row)"
                )
                    i.fa.fa-copy

        create-form(ref="createForm")
        clone-form(ref="cloneForm")
</template>

<script>
import { OrderLayoutEvent } from './order-layout-bus';
import Auth from '@js/plugins/auth';
import CollectionCounter from '@js/components/collection-counter';
import createForm from './order-layout-create-form.vue';
import cloneForm from './order-layout-clone.vue';
import orderLayout from '@js/store/modules/order-layout';
import PermissionMixin from './order-layout-permission';

export default {
    components: { CollectionCounter, createForm, cloneForm },

    mixins: [PermissionMixin],

    data() {
        let canManageSettings = Auth.hasPermissionTo(
            'franchise_manage_settings',
        );

        let actionButtons = [
            {
                title: `New ${this.trans('general.grid')} Layout`,
                action: () => {
                    this.showCreateForm();
                },
            },
        ];

        if (!canManageSettings) {
            actionButtons = [];
        }

        return {
            tableName: 'ORDER_LAYOUT',
            columns: [
                'name',
                // 'description',
                'grid_size',
                'outlet_id',
                'centrals',
                'action',
            ],
            options: {
                sortable: ['name', 'outlet_id'],
                headings: {
                    outlet_id: this.trans('general.outlet'),
                    action: '',
                    centrals: this.trans('general.centrals'),
                },
                columnsClasses: { action: 'prevent-click' },
                checkbox: canManageSettings,
                checkbox_actions: {
                    api_delete: Laroute.route('franchise.order_layout.delete'),
                    delete_title: 'Delete Order Layout',
                },
                useReportFilter: false,
                actionButtons: actionButtons,

                rowClickCallback(row) {
                    location.href = Laroute.route(
                        'franchise.order_layout.show',
                        { id: row.id },
                    );
                },

                rowClassCallback: () => 'pointer',
            },
        };
    },

    computed: {
        url() {
            return Laroute.route('franchise.order_layout.index');
        },

        centrals() {
            return this.trans('general.centrals');
        },
    },

    beforeCreate() {
        if (!this.$store._modules.get(['orderLayout']))
            this.$store.registerModule('orderLayout', orderLayout);
    },

    methods: {
        showCloneForm(row) {
            OrderLayoutEvent.$emit('clone-order-layout', row);
        },

        showCreateForm() {
            this.$refs.createForm.$emit('show');
        },

        onLoaded() {
            $('[data-toggle="tooltip"]').tooltip();
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/order-layout/order-layout-list.vue